import { FETCH_GROUPS_REQUEST } from 'constants/actionTypes/groups'

export default function requestAction() {
  return { type: FETCH_GROUPS_REQUEST }
}
